module.exports = __webpack_public_path__ + "assets/bottom-nav-menu.d6945e3e.svg";